import { render, staticRenderFns } from "./signH5.vue?vue&type=template&id=33113d96&scoped=true&"
import script from "./signH5.vue?vue&type=script&lang=js&"
export * from "./signH5.vue?vue&type=script&lang=js&"
import style0 from "./signH5.vue?vue&type=style&index=0&id=33113d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33113d96",
  null
  
)

export default component.exports